import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  smartNav: {
    overflow: 'hidden',
    position: 'relative',
    borderRight: "1px solid ".concat(palette.shades[300]),
    '&:after': {
      left: '0',
      right: '0',
      top: '84px',
      bottom: '0',
      opacity: '0',
      content: '""',
      display: 'block',
      position: 'absolute',
      visibility: 'hidden',
      transition: 'all .3s ease',
      background: 'linear-gradient(99deg, rgba(255, 255, 255, 0.00) 4.89%, #FFF 91.72%)'
    },
    '&.close': {
      width: '100px',
      '&:after': {
        opacity: '1',
        visibility: 'visible'
      }
    }
  },
  smartNavContent: {
    width: '260px',
    backgroundColor: palette.common.white,
    boxShadow: '0px 32px 32px 0px rgba(0, 0, 0, 0.15)'
  },
  smartNavControll: {
    display: 'flex',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    alignItems: 'center',
    padding: '8px 8px 0 24px',
    justifyContent: 'space-between',
    fontFamily: palette.fontFamilies.poppins,
    '& span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '&.close': {
      width: '100px',
      '& .MuiSvgIcon-root': {
        transform: 'rotateZ(180deg)'
      }
    }
  },
  smartNavControllTitle: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: palette.fontFamilies.poppins
  },
  smartNavSetting: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  smartNavSettingSearch: {
    display: 'flex',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& > div > div:first-child': {
      top: '6px',
      left: '10px'
    }
  },
  smartNavSettingFilter: {
    flexShrink: '0',
    marginLeft: '8px'
  },
  smartNavBody: {
    overflowY: 'auto',
    height: 'calc(100vh - 232px)'
  },
  smartNavItem: {
    display: 'flex',
    color: palette.shades[700],
    cursor: 'pointer',
    minHeight: '54px',
    position: 'relative',
    alignItems: 'center',
    padding: '12px 9px 12px 24px',
    justifyContent: 'space-between',
    '&:hover': {
      color: palette.common.black,
      backgroundColor: palette.shades[200]
    },
    '&.active': {
      color: palette.common.black,
      backgroundColor: palette.info.light,
      '&:after': {
        top: '0',
        right: '0',
        bottom: '0',
        width: '3px',
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundColor: palette.primary.main
      }
    }
  },
  smartNavItemIcon: {
    width: '24px',
    color: palette.common.white,
    height: '28px',
    flexShrink: '0',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '24px',
    marginRight: '8px',
    textAlign: 'center',
    // borderRadius: '50%',
    // backgroundColor: palette.info.main,
    fontFamily: palette.fontFamilies.poppins
  },
  smartNavItemDetails: {
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '& b': {
      display: 'block',
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '16px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: palette.fontFamilies.poppins
    },
    '& span': {
      color: palette.shades[700],
      fontSize: '11px',
      display: 'block',
      lineHeight: '14px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  smartNavItemNumber: {
    height: '20px',
    padding: '0 6px',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    marginLeft: '12px',
    borderRadius: '2px',
    backgroundColor: palette.warning.light,
    fontFamily: palette.fontFamilies.poppins
  }
});
export default useStyles;